export enum CardProgress {
  New, Learned, Know, Mastered
}

export function getColor(progress: CardProgress): string {
  switch (progress) {
    case CardProgress.New: return "error";
    case CardProgress.Learned: return "orange";
    case CardProgress.Know: return "yellowGreen";
    case CardProgress.Mastered: return "success";
  }
}


